import {
  Component,
  effect,
  inject,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiResponse } from '@core/api/apiresponse.model';
import { SimpleApi } from '@core/api/simple.api';
import { Kunde } from '@features/kunder/kunde.model';
import { ButtonModule } from 'primeng/button';
import { InputMaskModule } from 'primeng/inputmask';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-kunde-selector',
  imports: [FormsModule, ButtonModule, InputMaskModule, Popover],
  templateUrl: './kunde-selector.component.html',
  styleUrl: './kunde-selector.component.css',
})
export class KundeSelectorComponent {
  value = input<string | undefined>(undefined);
  kundeSelected = output<Kunde>();
  popover = viewChild<Popover>('pop');
  simpleApi = inject(SimpleApi);
  searchCpr = signal<string | undefined>(undefined);
  result = signal<Kunde[]>([]);

  constructor() {
    effect(() => {
      this.searchCpr.set(this.value());
    });
  }

  async findKunde(event: Event) {
    this.result.set([]);
    const cpr = this.searchCpr()?.replaceAll('-', '');
    if (cpr) {
      const response = await this.simpleApi.getSingle<ApiResponse<Kunde[]>>(
        '/api/admin/kunder',
        {
          filter: JSON.stringify({ cpr: cpr }),
        }
      );
      if (response && response.success) {
        const kunder = response.data;
        this.result.set(kunder);
      }
    }
    this.popover()!.show(event);
  }

  selectKunde(k: Kunde) {
    this.kundeSelected.emit(k);
    this.popover()!.hide();
  }
}
